<template>
  <div>
    <b-table
      ref="table-stock-counting-compliance"
      responsive
      show-empty
      striped
      class="mb-1 bordered"
      :empty-text="
        getEmptyTableMessage($t('regra de contagem por loja'), 'female', queryExecuted)
      "
      :fields="fields"
      :items="items"
    >
      <template #cell(compliancePercent)="{ item }">
        <b-badge :variant="complianceVariant(item)">
          {{ item.compliancePercent | percentage(0) }}
        </b-badge>
      </template>

      <template #cell(missedDays)="{ item }">
        <span
          v-if="item.missedDays > 0"
          v-b-tooltip.hover
          class="text-danger font-weight-bold cursor-pointer"
          :title="missedDatesTooltip(item)"
        >
          {{ item.missedDays }}
        </span>
        <span v-else>0</span>
      </template>

      <template #cell(daysOfWeek)="{ item }">
        {{ dayNames(item.daysOfWeek) }}
      </template>

      <template #cell(countings)="{ item }">
        {{ item.performedCountings }} / {{ item.requiredCountings }}
      </template>
    </b-table>

    <b-row>
      <b-col cols="6">
        <e-pagination-summary
          :current-page="paging.currentPage"
          :per-page="paging.pageSize"
          :total="paging.rowCount"
          :total-on-page="paging.rowsInCurrentPage"
        />
      </b-col>
      <b-col cols="6">
        <b-pagination
          :value="paging.currentPage"
          align="right"
          :total-rows="paging.rowCount"
          :per-page="paging.pageSize"
          aria-controls="table-stock-counting-compliance"
          @change="$emit('page-change', $event)"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { BRow, BCol, BTable, BPagination, BBadge, VBTooltip } from 'bootstrap-vue'
import { EPaginationSummary } from '@/views/components'
import { stockDomain } from '@/mixins'

export default {
  components: {
    BRow,
    BCol,
    BTable,
    BPagination,
    BBadge,
    EPaginationSummary,
  },

  directives: {
    'b-tooltip': VBTooltip,
  },

  mixins: [stockDomain],

  props: {
    items: {
      type: Array,
      default: () => [],
    },
    paging: {
      type: Object,
      required: true,
    },
    queryExecuted: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    fields() {
      return [
        {
          label: this.$t('Loja'),
          key: 'storeName',
          thStyle: { minWidth: '180px' },
        },
        {
          label: this.$t('Regra'),
          key: 'ruleDescription',
          formatter: (val, index, item) => `#${item.ruleId}${val ? ` - ${val}` : ''}`,
          thStyle: { minWidth: '160px' },
        },
        {
          label: this.$t('Grupo'),
          key: 'groupName',
          thStyle: { minWidth: '120px' },
        },
        {
          label: this.$t('Marcas'),
          key: 'brandNames',
          thStyle: { minWidth: '140px' },
        },
        {
          label: this.$t('Dias exigidos'),
          key: 'daysOfWeek',
          thStyle: { minWidth: '160px' },
        },
        {
          label: this.$t('Mín./dia'),
          key: 'minCountings',
          class: 'text-center',
          thStyle: { width: '90px' },
        },
        {
          label: this.$t('Dias no período'),
          key: 'requiredDays',
          class: 'text-center',
          thStyle: { width: '110px' },
        },
        {
          label: this.$t('Cumpridos'),
          key: 'fulfilledDays',
          class: 'text-center',
          thStyle: { width: '100px' },
        },
        {
          label: this.$t('Não cumpridos'),
          key: 'missedDays',
          class: 'text-center',
          thStyle: { width: '110px' },
        },
        {
          label: this.$t('Contagens'),
          key: 'countings',
          class: 'text-center',
          thStyle: { width: '110px' },
        },
        {
          label: this.$t('Aderência'),
          key: 'compliancePercent',
          class: 'text-center',
          thStyle: { width: '100px' },
        },
        {
          label: this.$t('Última contagem'),
          key: 'lastCountingDate',
          class: 'text-center',
          thStyle: { width: '140px' },
          formatter: value => (value ? this.$options.filters.datetime(value) : '-'),
        },
      ]
    },
  },

  methods: {
    complianceVariant(item) {
      if (item.compliancePercent >= 1) return 'success'
      if (item.compliancePercent >= 0.8) return 'warning'
      return 'danger'
    },

    dayNames(days) {
      if (!days?.length) return '-'
      const options = this.stockCountingDayOfWeekOptions()
      return days.map(day => options.find(o => o.value === day)?.label || day).join(', ')
    },

    missedDatesTooltip(item) {
      if (!item.missedDates?.length) return ''
      return `${this.$t('Dias sem contagem')}: ${item.missedDates
        .map(date => this.$options.filters.date(date))
        .join(', ')}`
    },
  },
}
</script>

<style lang="scss" scoped>
.cursor-pointer {
  cursor: pointer;
}
</style>
